import {
  CREATE_APP_VERSION_REQUEST,
  CREATE_APP_VERSION_SUCCESS,
  CREATE_APP_VERSION_FAILURE,
  FETCH_APP_VERSIONS_REQUEST,
  FETCH_APP_VERSIONS_SUCCESS,
  FETCH_APP_VERSIONS_FAILURE,
  UPDATE_APP_VERSION_REQUEST,
  UPDATE_APP_VERSION_SUCCESS,
  UPDATE_APP_VERSION_FAILURE,
} from "../actions/types";

const initialState = {
  appVersions: [],
  loading: false,
  error: null,
  message: "",
};


export default function appVersionReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_APP_VERSION_REQUEST:
    case FETCH_APP_VERSIONS_REQUEST:
    case UPDATE_APP_VERSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_APP_VERSION_SUCCESS:
      return {
        ...state,
        loading: false,
        appVersions: Array.isArray(state.appVersions)
          ? [action.payload, ...state.appVersions]
          : [action.payload],
        message: "App version created successfully",
      };

    case FETCH_APP_VERSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        appVersions: action.payload,
        message: "App versions loaded successfully",
      };

    case UPDATE_APP_VERSION_SUCCESS:
      return {
        ...state,
        loading: false,
        appVersions: Array.isArray(state.appVersions)
          ? state.appVersions.map((version) =>
              version.version_id === action.payload.version_id
                ? { ...version, ...action.payload }
                : version
            )
          : [],
        message: "App version updated successfully",
      };

    case CREATE_APP_VERSION_FAILURE:
    case FETCH_APP_VERSIONS_FAILURE:
    case UPDATE_APP_VERSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}